import ReactDOM from 'react-dom';
import routes from 'routes';
/* eslint no-unused-vars: 0 */
import css from 'revelr.scss';

ReactDOM.render(routes, document.getElementById('app'));



// WEBPACK FOOTER //
// ./app/assets/javascripts/apps/revelr.jsx